import { proLabGB2 } from "./ProductData/proLabGB2";
import { proLabGB3 } from "./ProductData/proLabGB3";
import { proLabGB4 } from "./ProductData/proLabGB4";
import { proLabGBCustom } from "./ProductData/proLabGBCustom";
import { filterPurificationService } from "./ServiceData/filterPurification";
import { gloveboxInspectionPM } from "./ServiceData/gloveboxMaintan";
import { sealGasketReplacementService } from "./ServiceData/sealGasketReplace";
import { sensorCleaningCalibrationService } from "./ServiceData/sensorCleaning";
import { customizationUpgradeSupportService } from "./ServiceData/techSupport";
import { vacuumInertGasService } from "./ServiceData/vaccumGasService";

export const dataConfig = {
    productsData:{
        proLabGB2:proLabGB2,
        proLabGB3:proLabGB3,
        proLabGB4:proLabGB4,
        proLabGBCustom:proLabGBCustom
    },
    servicesData:{
        filterPurification:filterPurificationService,
        gloveboxMaintan:gloveboxInspectionPM,
        sealGasketReplace:sealGasketReplacementService,
        sensorCleaning:sensorCleaningCalibrationService,
        techSupport:customizationUpgradeSupportService,
        vaccumGasService:vacuumInertGasService
    }
}